;(function injectFont() {
  // Check if the font is already injected
  if (document.querySelector("style#banzai-cardinal-font")) return

  const fontStyle = document.createElement("style")
  fontStyle.id = "banzai-cardinal-font"
  fontStyle.textContent = `
    @font-face {
      font-family: 'VC Banzai Cardinal';
      src:
        url('https://static-app-misc.banzai.org/fonts/VCBanzaiCardinalVF.woff2')
          format('woff2-variations'),
        url('https://static-app-misc.banzai.org/fonts/VCBanzaiCardinalVF.woff2')
          format('woff2');
      font-weight: 1 900;
      font-stretch: 75% 100%;
    }
  `
  document.head.appendChild(fontStyle)
})()

const fwaIcon = `
<svg width="160" height="151" viewBox="0 0 160 151" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3789_30157)">
<path d="M84.6601 31.9952L87.6032 37.9715L104.286 29.7572L107 35.2662L121.608 16.0829L97.3342 15.6484L100.187 21.4362L91.8252 25.5516L88.9641 19.7474L54.7539 34.3152L58.8447 42.6198L84.6519 31.987L84.6601 31.9952ZM87.3983 23.9858L90.3331 29.9457L104.581 22.9282L102.655 19.0178L115.083 19.2392L107.606 29.0603L105.786 25.363L89.1034 33.5774L86.2505 27.7896L60.4433 38.4224L59.2382 35.9712L87.4065 23.9776L87.3983 23.9858Z" fill="#1D1726"/>
<path d="M129.184 110.828H102.155V114.107H129.184V110.828Z" fill="#1D1726"/>
<path d="M76.2825 49.1719H46.1631V52.4511H76.2825V49.1719Z" fill="#1D1726"/>
<path d="M129.184 49.1719H81.5205V52.4511H129.184V49.1719Z" fill="#1D1726"/>
<path d="M76.2825 69.7266H46.1631V73.0058H76.2825V69.7266Z" fill="#1D1726"/>
<path d="M129.184 59.4453H46.1631V62.7245H129.184V59.4453Z" fill="#1D1726"/>
<path d="M59.2553 80H46.1631V83.2792H59.2553V80Z" fill="#1D1726"/>
<path d="M102.163 80H64.502V83.2792H102.163V80Z" fill="#1D1726"/>
<path d="M37.7519 126.993C39.58 126.256 40.4736 124.173 39.7358 122.337L37.3748 116.467C37.0222 115.582 36.3418 114.885 35.4564 114.508C34.5711 114.131 33.6037 114.123 32.7183 114.483L22.684 118.517C21.7986 118.869 21.1018 119.55 20.7247 120.435C20.3476 121.32 20.3394 122.288 20.7001 123.173L23.0611 129.043C23.4218 129.928 24.1022 130.625 24.9794 131.002C25.4303 131.191 25.9058 131.289 26.3813 131.289C26.8568 131.289 27.283 131.199 27.7175 131.027L37.7519 126.993ZM26.1025 127.821L23.7415 121.952C23.6841 121.796 23.7579 121.624 23.9055 121.566L33.9398 117.533C33.9398 117.533 34.0136 117.508 34.0546 117.508C34.1038 117.508 34.1448 117.517 34.1694 117.533C34.2185 117.558 34.2923 117.599 34.3251 117.697L36.6861 123.567C36.7435 123.722 36.6697 123.895 36.5222 123.952L26.4878 127.985C26.3321 128.043 26.1599 127.969 26.1025 127.821Z" fill="#1D1726"/>
<path d="M57.9618 125.064L28.9151 136.747C27.9238 137.146 27.4433 138.272 27.8421 139.264L28.0623 139.811C28.461 140.803 29.5879 141.283 30.5792 140.884L59.626 129.202C60.6173 128.803 61.0977 127.676 60.699 126.685L60.4788 126.137C60.08 125.146 58.9532 124.665 57.9618 125.064Z" fill="#1D1726"/>
<path d="M79.4569 116.412L64.8917 122.27C63.9003 122.669 63.4199 123.796 63.8186 124.787L64.0389 125.335C64.4376 126.326 65.5645 126.807 66.5558 126.408L81.121 120.55C82.1123 120.151 82.5928 119.024 82.194 118.033L81.9738 117.485C81.5751 116.494 80.4482 116.013 79.4569 116.412Z" fill="#1D1726"/>
<path d="M150.368 67.1248L141.26 64.2227C140.932 64.1161 140.612 64.0342 140.284 63.9522V7.26313C140.284 3.35269 137.103 0.171875 133.193 0.171875H43.1053C39.1949 0.171875 36.0141 3.35269 36.0141 7.26313V81.9139L16.9046 76.5115C13.3139 75.4949 9.5756 77.5936 8.55905 81.1761L0.262694 110.541C-0.229185 112.279 -0.0160375 114.107 0.869344 115.681C1.74653 117.255 3.18937 118.395 4.92735 118.887L12.2645 120.961L22.5694 146.58C23.2416 148.252 24.5287 149.572 26.1929 150.277C27.0455 150.638 27.9473 150.826 28.8409 150.826C29.7344 150.826 30.546 150.662 31.3658 150.334L66.3138 136.275H133.201C137.112 136.275 140.292 133.094 140.292 129.184V110C140.292 110 140.309 110 140.317 110C147.654 110 155.344 103.139 158.558 93.055C162.279 81.3811 158.615 69.7481 150.384 67.1248H150.368ZM153.729 73.4372L150.376 72.2157C150.007 71.5025 149.605 70.8221 149.163 70.1826L149.376 70.2482C151.114 70.8057 152.573 71.9206 153.729 73.4372ZM148.294 75.5769C149.892 79.8645 149.917 84.9226 148.359 89.8086C145.187 99.761 136.39 105.868 128.758 103.442C125.134 102.286 122.281 99.3593 120.732 95.2111C119.133 90.9235 119.109 85.8654 120.666 80.9794C120.855 80.3973 121.06 79.8317 121.281 79.266C121.396 78.9791 121.527 78.7003 121.658 78.4134C121.773 78.1593 121.88 77.9051 122.003 77.6592C122.175 77.3067 122.363 76.9624 122.552 76.6181C122.642 76.4623 122.724 76.2983 122.806 76.1508C123.019 75.7819 123.249 75.4294 123.478 75.0768C123.552 74.9621 123.626 74.8391 123.708 74.7325C123.954 74.38 124.2 74.0357 124.462 73.6996C124.544 73.593 124.626 73.4864 124.708 73.388C124.962 73.0683 125.233 72.7568 125.503 72.4535C125.61 72.3387 125.716 72.2239 125.815 72.1174C126.069 71.8468 126.339 71.5763 126.602 71.3222C126.749 71.1828 126.897 71.0516 127.053 70.9123C127.29 70.6991 127.536 70.486 127.782 70.281C128.004 70.1089 128.225 69.9449 128.446 69.7809C128.651 69.6252 128.864 69.4694 129.078 69.3218C129.127 69.2891 129.176 69.2563 129.225 69.2235C129.561 69.0021 129.897 68.8054 130.242 68.6168C130.332 68.5676 130.422 68.5184 130.504 68.4693C130.857 68.2807 131.217 68.1086 131.57 67.9528C131.611 67.9364 131.652 67.9118 131.685 67.8954C132.521 67.5347 133.382 67.2642 134.242 67.0838C134.291 67.0756 134.341 67.0592 134.39 67.051C135.267 66.8789 136.144 66.7887 137.03 66.8051C137.03 66.8051 137.038 66.8051 137.046 66.8051C137.497 66.8133 137.948 66.8543 138.399 66.9116L138.628 66.9444C139.177 67.0346 139.71 67.1576 140.243 67.3297C143.867 68.4857 146.72 71.4123 148.269 75.5605L148.294 75.5769ZM144.022 102.417L147.794 103.794C147.416 104.098 147.031 104.376 146.646 104.639L142.957 103.294C143.317 103.016 143.678 102.729 144.022 102.417ZM146.539 99.8429C146.925 99.3839 147.302 98.9002 147.662 98.4001L151.54 99.8183C151.171 100.318 150.794 100.802 150.409 101.253L146.547 99.8429H146.539ZM81.7998 93.5633H116.846C117.068 94.5224 117.322 95.457 117.658 96.367C118.232 97.9082 118.961 99.3101 119.822 100.564H84.6117L81.7998 93.5633ZM39.3015 7.26313C39.3015 5.16445 41.0067 3.45107 43.1135 3.45107H133.201C135.3 3.45107 137.013 5.15625 137.013 7.26313V63.5341C133.677 63.4849 130.283 64.5588 127.126 66.6985C125.856 67.5593 124.675 68.5922 123.585 69.7235H81.5375V73.0027H120.945C120.904 73.0683 120.855 73.1339 120.814 73.1995C120.781 73.2487 120.748 73.2979 120.716 73.3471C120.429 73.7816 120.158 74.2242 119.896 74.6751C119.814 74.8227 119.732 74.9785 119.65 75.126C119.437 75.5113 119.232 75.9048 119.035 76.3065C118.896 76.5853 118.773 76.8804 118.65 77.1673C118.519 77.4706 118.371 77.7658 118.248 78.0773C118.002 78.7003 117.764 79.3316 117.559 79.9792C117.559 79.9792 117.559 79.9874 117.559 79.9956H107.214V83.2748H116.756C116.305 85.6276 116.166 87.9887 116.354 90.2759H80.5127L80.2422 89.6037C79.9881 88.9642 79.6356 88.3822 79.2256 87.8739C79.2256 87.8739 79.2256 87.8657 79.2175 87.8575C79.1847 87.8247 79.1519 87.7919 79.1273 87.7509C77.8648 86.2671 76.0202 85.3981 74.0937 85.3653C73.4871 85.3571 72.8804 85.4309 72.2738 85.5866C72.0032 85.6604 71.7245 85.7424 71.454 85.849L66.1253 87.9887L62.6001 89.4069L39.3425 82.8239V7.26313H39.3015ZM13.3713 79.971C13.8959 79.6759 14.478 79.5283 15.0682 79.5283C15.388 79.5283 15.7077 79.5693 16.0192 79.6595L52.4674 89.9726L57.583 91.4236L46.737 95.7849L11.3874 85.7834C11.1496 85.7178 10.9119 85.7014 10.6823 85.726L11.7153 82.0697C11.9694 81.1761 12.5515 80.4301 13.3631 79.9792L13.3713 79.971ZM5.81273 115.731C4.91915 115.476 4.17313 114.894 3.72224 114.083C3.27135 113.271 3.15658 112.328 3.41072 111.435L8.40329 93.7764C8.59184 93.9158 8.79679 94.0306 9.03453 94.0962L33.6285 101.048L26.0208 104.106L12.6826 100.335C11.6497 100.04 10.584 100.638 10.2888 101.671L10.1495 102.155C9.85433 103.188 10.4528 104.253 11.4857 104.549L19.3804 106.778L14.6092 108.697C13.3877 109.189 12.3711 110 11.6251 111.05C11.6251 111.05 11.6169 111.058 11.6087 111.066C11.5103 111.205 11.4119 111.361 11.33 111.509C11.3054 111.541 11.289 111.582 11.2644 111.615C11.1906 111.746 11.125 111.886 11.0512 112.017C11.0184 112.074 10.9939 112.132 10.9611 112.197C10.9447 112.238 10.9201 112.279 10.9037 112.32C10.8627 112.41 10.8381 112.509 10.7971 112.599C10.7725 112.665 10.7479 112.73 10.7233 112.796C10.6741 112.935 10.6331 113.083 10.5921 113.222C10.5758 113.279 10.5594 113.337 10.543 113.394C10.5102 113.55 10.4774 113.698 10.4528 113.853C10.4446 113.911 10.4364 113.96 10.4282 114.017C10.4036 114.173 10.3872 114.329 10.379 114.485C10.379 114.542 10.379 114.599 10.3708 114.657C10.3708 114.812 10.3626 114.96 10.3708 115.116C10.3708 115.181 10.3708 115.247 10.3708 115.321C10.3708 115.46 10.3872 115.599 10.4036 115.739C10.4118 115.821 10.4282 115.903 10.4364 115.993C10.4528 116.116 10.4774 116.239 10.502 116.37C10.5266 116.468 10.543 116.567 10.5758 116.665C10.6085 116.78 10.6331 116.887 10.6741 117.001C10.6905 117.042 10.6987 117.083 10.7069 117.132L5.79633 115.747L5.81273 115.731ZM30.1279 147.285C29.2672 147.629 28.3162 147.621 27.4636 147.26C26.611 146.899 25.947 146.219 25.6027 145.358L14.9945 118.993L13.9041 116.272C13.814 116.05 13.7484 115.829 13.7074 115.599C13.7074 115.558 13.7074 115.517 13.6992 115.476C13.6746 115.288 13.65 115.099 13.65 114.911C13.65 114.894 13.65 114.878 13.65 114.853C13.6828 113.993 14.0271 113.173 14.6256 112.55C14.642 112.533 14.6583 112.509 14.6747 112.492C14.8059 112.361 14.9535 112.255 15.101 112.14C15.1338 112.115 15.1666 112.083 15.2076 112.058C15.3962 111.935 15.6093 111.82 15.8307 111.73L62.7395 92.8665L72.6345 88.8904C72.8558 88.8003 73.0772 88.7429 73.2985 88.7019C73.3723 88.6855 73.4379 88.6937 73.5117 88.6855C73.6674 88.6691 73.815 88.6445 73.9707 88.6445C74.0117 88.6445 74.0527 88.6445 74.0855 88.6527C74.2495 88.6527 74.4134 88.6773 74.5774 88.7101C74.6348 88.7183 74.7004 88.7347 74.7578 88.7511C74.9053 88.7839 75.0447 88.833 75.184 88.8904C75.2332 88.9068 75.2906 88.9232 75.3398 88.9478C75.5202 89.0298 75.7005 89.12 75.8727 89.2347C75.8973 89.2511 75.9137 89.2675 75.9383 89.2839C76.0858 89.3823 76.217 89.4971 76.3482 89.6201C76.3973 89.661 76.4383 89.7102 76.4793 89.7594C76.5777 89.866 76.6761 89.9808 76.7663 90.1037C76.799 90.1529 76.84 90.2021 76.8728 90.2595C76.9876 90.4398 77.086 90.6202 77.168 90.8252L88.8665 119.912C89.0468 120.354 89.1288 120.822 89.1206 121.272C89.096 122.625 88.2762 123.904 86.9399 124.445L57.5256 136.275L30.1443 147.293L30.1279 147.285ZM136.997 129.184C136.997 131.282 135.292 132.996 133.185 132.996H74.4462L88.1451 127.487C89.6781 126.872 90.8668 125.749 91.5882 124.388H129.176V121.109H92.3752C92.367 120.297 92.2113 119.485 91.8915 118.69L90.047 114.107H95.4413V110.828H88.7271L86.0382 104.147L85.9152 103.835H122.782C124.249 105.057 125.913 105.983 127.741 106.565L136.849 109.467C136.898 109.484 136.939 109.492 136.989 109.508V129.184H136.997ZM139.153 106.639L138.923 106.598C138.546 106.532 138.186 106.442 137.858 106.344L137.587 106.262C138.21 106.041 138.825 105.786 139.432 105.491L142.285 106.532C141.227 106.754 140.178 106.795 139.145 106.639H139.153ZM155.418 92.0549C154.86 93.8174 154.147 95.457 153.327 96.9736L149.45 95.5554C150.253 94.0716 150.95 92.4893 151.483 90.8006C153.048 85.8982 153.204 80.8154 151.958 76.2819L155.869 77.7084C157.115 81.7336 157.074 86.8737 155.426 92.063L155.418 92.0549Z" fill="#1D1726"/>
<path d="M137.02 75.6562C137.291 75.0986 137.943 74.823 138.532 75.043L138.751 75.124L138.727 75.1475C139.224 75.4419 139.46 76.0557 139.252 76.6133L138.573 78.4785L143.45 80.2568L143.565 80.3057C144.086 80.5588 144.36 81.1439 144.216 81.7002L144.179 81.8184C143.946 82.4519 143.246 82.7803 142.617 82.5459L132.593 78.8818V78.8828C132.122 78.7142 131.591 78.9591 131.414 79.4307L131.415 79.4316L130.686 81.4404C130.517 81.9112 130.763 82.4401 131.234 82.6172H131.235L139.253 85.5439C140.986 86.1789 141.887 88.1088 141.252 89.8428L140.522 91.8516V91.8525C139.887 93.5857 137.957 94.4868 136.223 93.8516L133.355 92.8037L132.678 94.6719L132.677 94.6729C132.444 95.3064 131.744 95.6348 131.115 95.4004V95.4014C130.482 95.1684 130.153 94.4683 130.387 93.8398L131.064 91.9717L126.697 90.376C126.064 90.143 125.735 89.451 125.969 88.8145C126.202 88.1807 126.902 87.8515 127.53 88.0859H127.529L137.056 91.5615H137.055C137.526 91.7304 138.056 91.4834 138.232 91.0107L138.962 89.0029C139.13 88.5317 138.884 88.0026 138.411 87.8262V87.8252L130.395 84.8994C128.661 84.2644 127.759 82.3338 128.395 80.5996L129.124 78.5918H129.125C129.76 76.8585 131.69 75.9568 133.424 76.5918L136.291 77.6387L136.97 75.7715L137.02 75.6562Z" fill="#1D1726" stroke="black" stroke-width="0.3"/>
</g>
<defs>
<clipPath id="clip0_3789_30157">
<rect width="160" height="150.654" fill="white" transform="translate(0 0.171875)"/>
</clipPath>
</defs>
</svg>
`

class BzFwa extends HTMLElement {
  constructor() {
    super()
    // Attach Shadow DOM in closed mode
    this.root = this.attachShadow({mode: "closed"})
    this.isRendering = false
    this.isFullscreen = false
    this.isCoachMode = false
    this.originalBodyOverflow = null // Store original body overflow style

    // Use the current subdomain.domain.com as the appBaseUrl
    this.appBaseUrl = `${window.location.protocol}//${window.location.host}`
  }

  // Helper method to extract FWA theme from body classes
  getFwaTheme() {
    const bodyClasses = document.body.className
    const fwaThemeMatch = bodyClasses.match(/fwa-theme-([a-zA-Z0-9-]+)/)
    return fwaThemeMatch ? fwaThemeMatch[1] : null
  }

  // Helper method to extract CSS variables from parent document
  getCssVariables() {
    const computedStyle = getComputedStyle(document.documentElement)
    return {
      primaryColor: computedStyle.getPropertyValue("--bz-color-primary-1").trim() || "#004A76",
      onPrimary: computedStyle.getPropertyValue("--bz-color-on-primary").trim() || "#FFFFFF",
      secondaryColor: computedStyle.getPropertyValue("--bz-color-secondary-1").trim() || "#F2F0EF",
      onSecondary: computedStyle.getPropertyValue("--bz-color-on-secondary").trim() || "#000000"
    }
  }

  static get observedAttributes() {
    return []
  }

  connectedCallback() {
    this.render()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render()
    }
  }

  async render() {
    // Prevent multiple simultaneous renders
    if (this.isRendering) return
    this.isRendering = true

    try {
      // Clear previous content
      while (this.root.firstChild) {
        this.root.removeChild(this.root.firstChild)
      }

      // Get CSS variables from parent document for theming
      const cssVars = this.getCssVariables()

      // Inject styles into Shadow DOM
      const styleElement = document.createElement("style")
      styleElement.textContent = `
        :host {
          font-family: 'VC Banzai Cardinal', sans-serif;
          container-type: inline-size;
        }

        .fwa-wrapper {
          width: 100%;
          max-width: 1200px;
          margin: 48px auto;
          text-align: center;
          color: #ffffff;
          font-family: "Cardinal Grotesque";
          font-size: 14px;
          line-height: 1.11;
          position: relative;
        }

        @container (min-width: 1200px) {
          .fwa-wrapper {
            overflow: hidden;
            border-radius: 8px;
          }
        }
        
        .fwa-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 3rem 2rem;
          text-align: center;
          max-width: 960px;
          height: 640px;
          position: relative;
          box-sizing: border-box;
          border-radius: var(--Radius-Loose, 16px);
          background: var(--App-Colors-Containers-Neutral-Lowest, #FFF);
          margin: 0 auto;
        }
        
        @media (max-width: 768px) {
          .fwa-container {
            width: calc(100vw - 20px);
            padding: 3rem 32px;
          }
        }
        
        .fwa-container.fwa-coach-mode {
          padding: 0;
          height: 640px;
          box-sizing: border-box;
        }
        
        .fwa-icon {
          width: 80px;
          height: 80px;
          margin-bottom: 2rem;
          fill: #4a5568;
        }
        
        .fwa-title {
          color: #1E1E1E;
          text-align: center;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: "VC Banzai Cardinal";
          font-size: 40px;
          font-style: normal;
          font-weight: 440;
          line-height: 100%;
          margin-bottom: 1rem;
        }
        
        .fwa-subtitle {
          color: #1E1E1E;
          text-align: center;
          font-family: "VC Banzai Cardinal";
          font-size: 18px;
          font-style: normal;
          font-weight: 320;
          line-height: 27px;
          letter-spacing: 0.36px;
          margin-bottom: 0.5rem;
        }
        
        .fwa-description {
          color: #1E1E1E;
          text-align: center;
          font-family: "VC Banzai Cardinal";
          font-size: 18px;
          font-style: normal;
          font-weight: 320;
          line-height: 27px;
          letter-spacing: 0.36px;
          margin-bottom: 2rem;
        }
        
        .fwa-button {
          display: flex;
          height: 48px;
          max-height: 48px;
          padding: var(--Spacing-XS, 8px) var(--Spacing-L, 24px);
          justify-content: center;
          align-items: center;
          gap: var(--Spacing-S, 12px);
          background: ${cssVars.primaryColor};
          color: ${cssVars.onPrimary};
          border-radius: 2rem;
          font-size: 1.125rem;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 4px 12px rgba(0, 74, 118, 0.3);
          margin: 0 auto;
        }
        
        .fwa-button:hover {
          background: ${cssVars.primaryColor};
          opacity: 0.8;
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(0, 74, 118, 0.4);
        }
        
        .fwa-button:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(0, 74, 118, 0.3);
        }
        
        .fwa-fullscreen-btn {
          position: absolute;
          top: 0px;
          right: 0px;
          padding: 12px 16px;
          background: none;
          border: none;
          cursor: pointer;
          border-radius: 0.5rem;
          transition: background-color 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }
        
        .fwa-fullscreen-btn:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
        
        .fwa-fullscreen-btn svg {
          width: 24px;
          height: 24px;
        }
        
        .fwa-iframe-container {
          width: 100%;
          height: 100%;
          border: none;
          border-radius: 16px;
          overflow: hidden;
        }
        
        .fwa-iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
        
        .fwa-wrapper.fwa-fullscreen {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 10000;
          padding: 0;
          margin: 0;
        }
        
        .fwa-wrapper.fwa-fullscreen .fwa-container {
          width: 100vw;
          height: 100vh;
          border-radius: 0;
          max-width: none;
        }
        
        .fwa-wrapper.fwa-fullscreen .fwa-iframe-container {
          height: 100%;
          border-radius: 0;
        }
        
        /* Override media query padding for fullscreen */
        @media (min-width: 768px) {
          .fwa-wrapper.fwa-fullscreen {
            padding: 0;
          }
        }
        
        @media (min-width: 996px) {
          .fwa-wrapper.fwa-fullscreen {
            padding: 0;
          }
        }
        
        @media (min-width: 1200px) and (min-height: 790px) {
          .fwa-wrapper.fwa-fullscreen {
            padding: 0;
          }
        }
        
        .hidden {
          display: none;
        }

        .fwa-grey {
          border-radius: var(--Radius-Loose, 16px);
          background: var(--App-Colors-Containers-Neutral-Low, #F2F0EF);
        }

        .fwa-fuchsia {
          border-radius: var(--Radius-Loose, 16px);
          background: #F4EAF5;
        }

        .fwa-purple {
          border-radius: var(--Radius-Loose, 16px);
          background: #EBE7F4;
        }

        .fwa-navy-blue {
          border-radius: var(--Radius-Loose, 16px);
          background: #EAF0F7;
        }

        .fwa-blue {
          border-radius: var(--Radius-Loose, 16px);
          background: #ECF5FF;
        }

        .fwa-teal {
          border-radius: var(--Radius-Loose, 16px);
          background: #ECF9FA;
        }

        .fwa-green {
          border-radius: var(--Radius-Loose, 16px);
          background: #E4F4E6;
        }

        .fwa-bright-green {
          border-radius: var(--Radius-Loose, 16px);
          background: #EDF6E7;
        }

        .fwa-yellow {
          border-radius: var(--Radius-Loose, 16px);
          background: #FFFEED;
        }

        .fwa-gold {
          border-radius: var(--Radius-Loose, 16px);
          background: #F5EFE4;
        }

        .fwa-orange {
          border-radius: var(--Radius-Loose, 16px);
          background: #FDF5E8;
        }

        .fwa-red {
          border-radius: var(--Radius-Loose, 16px);
          background: #F5E9E9;
        }

        .fwa-red-to-green {
          border-radius: var(--Radius-Loose, 16px);
          background: linear-gradient(151deg, #F5E9E9 13.2%, #FFF4E1 49.77%, #F1FFE4 86.35%);
        }

        .fwa-green-to-blue {
          border-radius: var(--Radius-Loose, 16px);
          background: var(--Green-to-blue, linear-gradient(151deg, #E5FFE1 13.2%, #E4EAFF 86.35%));
        }

        .fwa-blue-to-purple {
          border-radius: var(--Radius-Loose, 16px);
          background: linear-gradient(151deg, #E1F4FF 13.2%, #F4E4FF 86.35%);
        }

        .fwa-purple-to-orange {
          border-radius: var(--Radius-Loose, 16px);
          background: linear-gradient(151deg, #EFE1FF 13.2%, #FFE4E5 86.35%);
        }

        .fwa-fuchsia-to-yellow {
          border-radius: var(--Radius-Loose, 16px);
          background: linear-gradient(151deg, #FFE1ED 13.2%, #FEFFE4 86.35%);
        }

        .fwa-rainbow {
          border-radius: var(--Radius-Loose, 16px);
          background: linear-gradient(170deg, #FFE1E1 7.21%, #FDFFE3 20.05%, #E4FEE7 40.77%, #E6E8F1 63.56%, #F1E6F2 81.79%, #FFE4F1 93.39%);
        }

        .fwa-white {
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 1px 3px 1px rgba(0, 0, 0, 0.15);
        }
      `
      this.root.appendChild(styleElement)

      // Create wrapper div for responsive behavior
      const wrapperDiv = document.createElement("div")
      wrapperDiv.className = "fwa-wrapper"

      // Add content container inside wrapper
      const contentDiv = document.createElement("div")
      // Get FWA theme from body classes (set by server-side sponsor data)
      const fwaTheme = this.getFwaTheme()
      const containerClass = fwaTheme ? `fwa-${fwaTheme}` : "fwa-green-to-blue"
      contentDiv.className = `fwa-container ${containerClass}`
      contentDiv.id = "fwa-content"

      // Create the Financial Wellness Assessment interface without header
      contentDiv.innerHTML = `
                <button class="fwa-fullscreen-btn" id="enter-fullscreen">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19 10C18.45 10 18 9.55 18 9V6H15C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4H18C19.1 4 20 4.9 20 6V9C20 9.55 19.55 10 19 10ZM4 18V15C4 14.45 4.45 14 5 14C5.55 14 6 14.45 6 15V18H9C9.55 18 10 18.45 10 19C10 19.55 9.55 20 9 20H6C4.9 20 4 19.1 4 18ZM4 9V6C4 4.9 4.9 4 6 4H9C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6H6V9C6 9.55 5.55 10 5 10C4.45 10 4 9.55 4 9ZM14 19C14 18.45 14.45 18 15 18H18V15C18 14.45 18.45 14 19 14C19.55 14 20 14.45 20 15V18C20 19.1 19.1 20 18 20H15C14.45 20 14 19.55 14 19Z" fill="black"/>
                    </svg>
                </button>
                <button class="fwa-fullscreen-btn hidden" id="exit-fullscreen">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 10C14.9 10 14 9.1 14 8V5C14 4.45 14.45 4 15 4C15.55 4 16 4.45 16 5V8H19C19.55 8 20 8.45 20 9C20 9.55 19.55 10 19 10H16ZM4 15C4 14.45 4.45 14 5 14H8C9.1 14 10 14.9 10 16V19C10 19.55 9.55 20 9 20C8.45 20 8 19.55 8 19V16H5C4.45 16 4 15.55 4 15ZM4 9C4 8.45 4.45 8 5 8H8V5C8 4.45 8.45 4 9 4C9.55 4 10 4.45 10 5V8C10 9.1 9.1 10 8 10H5C4.45 10 4 9.55 4 9ZM14 19V16C14 14.9 14.9 14 16 14H19C19.55 14 20 14.45 20 15C20 15.55 19.55 16 19 16H16V19C16 19.55 15.55 20 15 20C14.45 20 14 19.55 14 19Z" fill="black"/>
                    </svg>
                </button>
                
                <div class="fwa-main-content">
                    ${fwaIcon}
                    
                    <h1 class="fwa-title">Financial Wellness Assessment</h1>
                    
                    <p class="fwa-subtitle">Your all-in-one financial wellness coach, here to guide you toward achieving your financial goals.</p>
                    
                    <p class="fwa-description">Estimated length: 12 minutes.</p>
                    
                    <button class="fwa-button" data-coach-action="start">Begin Assessment</button>
                </div>
            `

      wrapperDiv.appendChild(contentDiv)
      this.root.appendChild(wrapperDiv)

      this.setupEventHandlers(contentDiv)
    } catch (error) {
      console.error("Error in render:", error)
      this.showError(contentDiv, "Render Error", error.message, "An unexpected error occurred while rendering the FWA component.")
    } finally {
      this.isRendering = false
    }
  }

  setupEventHandlers(container) {
    // Setup fullscreen buttons
    const enterFullscreenBtn = container.querySelector("#enter-fullscreen")
    const exitFullscreenBtn = container.querySelector("#exit-fullscreen")

    enterFullscreenBtn?.addEventListener("click", () => {
      this.enterFullscreen()
    })

    exitFullscreenBtn?.addEventListener("click", () => {
      this.exitFullscreen()
    })

    // Setup coach button
    const coachButtons = container.querySelectorAll("button[data-coach-action], .fwa-button")

    coachButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault()
        this.startCoach()
      })
    })
  }

  enterFullscreen() {
    this.isFullscreen = true
    const wrapperDiv = this.root.querySelector(".fwa-wrapper")
    const enterBtn = this.root.querySelector("#enter-fullscreen")
    const exitBtn = this.root.querySelector("#exit-fullscreen")

    // Store original body overflow and prevent scrolling
    this.originalBodyOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"

    wrapperDiv.classList.add("fwa-fullscreen")
    enterBtn.classList.add("hidden")
    exitBtn.classList.remove("hidden")
  }

  exitFullscreen() {
    this.isFullscreen = false
    const wrapperDiv = this.root.querySelector(".fwa-wrapper")
    const enterBtn = this.root.querySelector("#enter-fullscreen")
    const exitBtn = this.root.querySelector("#exit-fullscreen")

    // Restore original body overflow behavior
    document.body.style.overflow = this.originalBodyOverflow || ""
    this.originalBodyOverflow = null

    wrapperDiv.classList.remove("fwa-fullscreen")
    enterBtn.classList.remove("hidden")
    exitBtn.classList.add("hidden")
  }

  startCoach() {
    this.isCoachMode = true
    const contentDiv = this.root.querySelector("#fwa-content")

    // Get FWA theme from body classes (same as in render method)
    const fwaTheme = this.getFwaTheme() || "green-to-blue" // Always have a theme

    // Add coach mode class to remove padding
    contentDiv.classList.add("fwa-coach-mode")

    // Build the coach URL with hardcoded 'fwa' slug
    const coachUrl = new URL(`${this.appBaseUrl}/coach/start/fwa`)

    // Subdomain context is available server-side via meta tags and session

    // Always add fwa-theme parameter (either from Salesforce or default)
    coachUrl.searchParams.append("fwa-theme", fwaTheme)

    // Determine button visibility based on current fullscreen state
    const enterBtnClass = this.isFullscreen ? "fwa-fullscreen-btn hidden" : "fwa-fullscreen-btn"
    const exitBtnClass = this.isFullscreen ? "fwa-fullscreen-btn" : "fwa-fullscreen-btn hidden"

    // Replace content with iframe, without the header wrapper
    contentDiv.innerHTML = `
            <button class="${enterBtnClass}" id="enter-fullscreen">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 10C18.45 10 18 9.55 18 9V6H15C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4H18C19.1 4 20 4.9 20 6V9C20 9.55 19.55 10 19 10ZM4 18V15C4 14.45 4.45 14 5 14C5.55 14 6 14.45 6 15V18H9C9.55 18 10 18.45 10 19C10 19.55 9.55 20 9 20H6C4.9 20 4 19.1 4 18ZM4 9V6C4 4.9 4.9 4 6 4H9C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6H6V9C6 9.55 5.55 10 5 10C4.45 10 4 9.55 4 9ZM14 19C14 18.45 14.45 18 15 18H18V15C18 14.45 18.45 14 19 14C19.55 14 20 14.45 20 15V18C20 19.1 19.1 20 18 20H15C14.45 20 14 19.55 14 19Z" fill="black"/>
                </svg>
            </button>
            <button class="${exitBtnClass}" id="exit-fullscreen">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 10C14.9 10 14 9.1 14 8V5C14 4.45 14.45 4 15 4C15.55 4 16 4.45 16 5V8H19C19.55 8 20 8.45 20 9C20 9.55 19.55 10 19 10H16ZM4 15C4 14.45 4.45 14 5 14H8C9.1 14 10 14.9 10 16V19C10 19.55 9.55 20 9 20C8.45 20 8 19.55 8 19V16H5C4.45 16 4 15.55 4 15ZM4 9C4 8.45 4.45 8 5 8H8V5C8 4.45 8.45 4 9 4C9.55 4 10 4.45 10 5V8C10 9.1 9.1 10 8 10H5C4.45 10 4 9.55 4 9ZM14 19V16C14 14.9 14.9 14 16 14H19C19.55 14 20 14.45 20 15C20 15.55 19.55 16 19 16H16V19C16 19.55 15.55 20 15 20C14.45 20 14 19.55 14 19Z" fill="black"/>
                </svg>
            </button>
            <div class="fwa-iframe-container">
                <iframe class="fwa-iframe" src="${coachUrl.toString()}" allow="camera; microphone; autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>
            </div>
        `

    // Re-setup event handlers for the new buttons
    this.setupEventHandlers(contentDiv)
  }

  showError(container, title, message, details) {
    container.innerHTML = `
            <div class="coach-error-container">
                <div class="coach-error-header">
                    <svg class="coach-error-icon" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                    </svg>
                    <div class="coach-error-title">${title}</div>
                </div>
                <div class="coach-error-message">${message}</div>
                <div class="coach-error-details">${details}</div>
            </div>
        `
  }

  disconnectedCallback() {
    // Clean up event listeners if needed
    // (Shadow DOM cleanup is handled automatically)

    // If component is removed while in fullscreen, restore body overflow
    if (this.isFullscreen && this.originalBodyOverflow !== null) {
      document.body.style.overflow = this.originalBodyOverflow || ""
      this.originalBodyOverflow = null
    }
  }
}

customElements.define("bz-fwa", BzFwa)
